export enum DatabaseEntities {
  ACCESS = "access",
  APPOINTMENTS = "appointments",
  ATTACHMENTS = "attachments",
  AUTH = "auth",
  BUNDLES = "bundles",
  ULTRA_BUNDLES = "bundles/ultra",
  BUNDLE_ITEMS = "bundleItems",
  CATEGORIES = "categories",
  CLIENTS = "clients",
  CLIENT_LEVELS = "levels",
  CLIENT_TYPES = "types",
  CONTRACTORS = "contractors",
  EMAIL_TEMPLATES = "emailTemplates",
  EMPLOYES = "employees",
  EMPLOYEE_ROLES = "employees/roles",
  ERRORS = "errors",
  ESTIMATES = "estimates",
  FAQS = "faqs",
  GALLERY = "gallery",
  IMAGES = "images",
  LOGS = "logs",
  MESSAGES = "messages",
  PAYMENT_METHODS = "paymentMethods",
  PERMISSIONS = "permissions",
  PRODUCTS = "products",
  PROJECTS = "projects",
  PROJECT_TYPES = "projectTypes",
  REQUESTS = "requests",
  REVIEWS = "reviews",
  ROLES = "roles",
  PLACES = "places",
  SERVICE_TYPES = "serviceTypes",
  SERVICES = "services",
  SESSIONS = "sessions",
  STAGED_PAYMENTS = "stagedPayments",
  STATUS = "status",
  TAGS = "tags",
  TAG_GROUPS = "tagGroups",
  TEAMS = "teams",
  TEAM_MEMBERS = "members",
  USERS = "users",
  VENDORS = "vendors",
}
